<section class="cej-what-are-we-doing">
  <article class="cej-what-are-we-doing__article">
    <h2 class="cej-what-are-we-doing__article__title">
      Concrètement qu&apos;est ce qu&apos;on fait en Contrat d&apos;Engagement Jeune&nbsp;?
    </h2>
    <aside>
      <p>
        Accueilli au sein de Pôle emploi ou de ma Mission Locale, en fonction de mon profil, de mes compétences et de
        mes envies, je pourrai avoir accès à&nbsp;:
      </p>
      <ul class="cej-what-are-we-doing__article__proposal-list">
        <li>
          <em class="cej-what-are-we-doing__article__proposal-list__emphasis">
            Des points réguliers en tête-à-tête avec mon conseiller
          </em>
        </li>
        <li>
          <em class="cej-what-are-we-doing__article__proposal-list__emphasis">Des ateliers collectifs</em>
          avec d&apos;autres jeunes pour partager nos expériences
        </li>
        <li>
          <em class="cej-what-are-we-doing__article__proposal-list__emphasis">
            Des stages et immersions en entreprise
          </em>
          pour découvrir différents métiers
        </li>
        <li>
          <em class="cej-what-are-we-doing__article__proposal-list__emphasis">
            Toutes les solutions du plan <q> 1 jeune, 1 solution </q>&nbsp;:
          </em>
          formations qualifiantes, service civique, prépa apprentissage, école de la 2<sup>ème</sup> chance (E2C),
          Epide, etc.
        </li>
        <li>
          <em class="cej-what-are-we-doing__article__proposal-list__emphasis">
            Une appli pour suivre l&apos;évolution de mon parcours
          </em>
          et tenir mes engagements
        </li>
      </ul>
    </aside>
  </article>
</section>
